// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { Switch, Route } from 'react-router-dom'
import { withRouter } from 'react-router'

// Internal Dependencies:
import PageHeader from 'components/PageHeader/PageHeader'
import Page from 'views/page/Page'
import Footer from 'components/Footer/Footer'
import HomeImageLinks from 'components/PageHeader/HomeImageLinks'

// Redux:
import { getPageData } from 'actions/page'

const siteImage = siteData.site_featured_image_url
const siteImageSrcset = siteData.site_featured_image_srcset

class MainLayout extends React.Component {
	componentDidMount() {
		// Page:
		const { params, path } = this.props.match

		if ( '/' == path ) {
			this.props.getPost( 'home', 'page' )
		} else if ( '/schedule-item/:time' == path ) {
			this.props.getPost( 'schedule', 'page' )
		} else if ( params.page ) {
			if ( params.archivePageNumber ) {
				this.props.getPost( params.page, 'page', params.archivePageNumber )
			} else {
				this.props.getPost( params.page, 'page' )
			}
		} else if ( params.video ) {
			this.props.getPost( 'videos', 'page' )
		}
	}

	componentDidUpdate( prevProps ) {
		// Page:
		if ( this.props.match ) {
			const { params, path } = this.props.match
			const prevParams = prevProps.match.params
			const prevPath = prevProps.match.path

			if ( '/' == path && '/' !== prevPath ) {
				window.scrollTo( 0, siteData.page_top_pos )
				document.querySelector( '.main' ).scrollTop = 0

				this.props.getPost( 'home', 'page' )
			} else if ( params.page && prevParams.page !== params.page ) {
				window.scrollTo( 0, siteData.page_top_pos )
				document.querySelector( '.main' ).scrollTop = 0

				this.props.getPost( params.page, 'page' )
			} else if ( params.page && params.archivePageNumber && prevParams.archivePageNumber !== params.archivePageNumber ) {
				window.scrollTo( 0, siteData.page_top_pos )
				document.querySelector( '.main' ).scrollTop = 0

				this.props.getPost( params.page, 'page', params.archivePageNumber )
			} else if ( params.video && prevParams.video !== params.video ) {
				this.props.getPost( 'videos', 'page' )
			}
		}
	}

	render() {
		const { hasSidebar, location, match, page, isMobile } = this.props
		let className = ''

		let showPageHeader = true,
			showPrimaryContent = true,
			showSecondaryContent = true

		if ( page && page.template ) {
			className += ` page-${page.template}`
		}

		return (
			<div className={ className }>
				{ showPageHeader &&
					<PageHeader match={ match } location={ location } />
				}

				<div className="main-inner">
					{ showPrimaryContent &&
						<div className="primary-wrap">
							<div className="primary-content">
								<Switch key={ location.key } location={ location }>
									<Route path="/" exact component={ Page } />

									<Route path="/:page" exact component={ Page } />
									<Route path="/video/:video" exact component={ Page } />
									<Route path="/videos/:video" exact component={ Page } />
									<Route path="/:parent/:page" exact component={ Page } />
									<Route component={ Page } />
								</Switch>
							</div>
						</div>
					}

					{ showSecondaryContent &&
						<div className="secondary-wrap">
							<div className="secondary-content">
								<aside className="secondary-image-links">
									<HomeImageLinks />
								</aside>
							</div>
						</div>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		hasSidebar: state.site.hasSidebar,
		page: state.page.selected,
		isMobile: state.site.isMobile
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getPost: ( slug, type, archivePageNumber ) => {
			dispatch( getPageData( slug, type, archivePageNumber ) )
		}
	}
}

export default withRouter(
	connect( mapStateToProps, mapDispatchToProps )( MainLayout )
)



// WEBPACK FOOTER //
// ./layouts/MainLayout.jsx